import {
  DeleteOutlined,
  DownloadOutlined,
  EyeOutlined,
  PictureOutlined,
  VideoCameraOutlined
} from "@ant-design/icons"
import { Button, Flex, Typography, message } from "antd"
import React, { Fragment, type ReactNode, useState } from "react"

import { downloadFile } from "../../utils/download-file.ts"
import { FilePreviewModal } from "../FilePreviewModal/FilePreviewModal.tsx"

const { Text } = Typography

interface AttachmentsListProps {
  attachments: any[]
  onDelete?: (file: any) => void
  preview?: boolean
  children?: ReactNode
}

export const AttachmentsList = ({
  attachments,
  children,
  onDelete,
  preview
}: AttachmentsListProps) => {
  const [selectedDocument, setSelectedDocument] = useState(null)

  if (!attachments?.length) return null

  const getFileName = (file: any) =>
    file?.["file_name"] ||
    file?.["original_filename"] ||
    file?.["name"] ||
    "document"

  const onDownloadFile = async (file: any) => {
    const href = file?.["file"]
    const name = getFileName(file)

    if (!href) return message.error("File not found")

    await downloadFile(href, name)
  }

  return (
    <>
      {children}
      <div
        className={
          "px-0.5 grid grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-4"
        }
      >
        {attachments?.map((file, idx) => {
          const name = getFileName(file)

          return (
            <Flex
              key={file?.id || `${name}-${idx}`}
              gap={8}
              align="center"
              style={{
                border: "1px solid #f0f0f0",
                borderRadius: 8,
                padding: "8px 16px"
              }}
            >
              {preview ? null : [".png", ".jpeg", ".jpg"].some((ext) =>
                  name?.endsWith(ext)
                ) ? (
                <PictureOutlined style={{ fontSize: 20, lineHeight: 1 }} />
              ) : (
                <VideoCameraOutlined style={{ fontSize: 20, lineHeight: 1 }} />
              )}
              <Flex
                gap={2}
                vertical={true}
                style={{ minWidth: 0 }}
                className={"flex-1"}
              >
                <Text ellipsis={{ tooltip: name }}>{name}</Text>
                <Text
                  type="secondary"
                  style={{ fontSize: 12, lineHeight: 1.5 }}
                >
                  Created: {file?.["created"]}
                </Text>
              </Flex>

              <Flex gap={2} style={{ marginLeft: "auto", paddingLeft: 12 }}>
                <Button
                  size="small"
                  type="link"
                  shape="circle"
                  onClick={() => setSelectedDocument(file)}
                  style={{ cursor: "pointer!important" }}
                  disabled={false}
                  icon={<EyeOutlined />}
                />
                {onDelete ? (
                  <Button
                    size="small"
                    type="link"
                    shape="circle"
                    icon={<DeleteOutlined />}
                    onClick={() => onDelete(file)}
                    className="flex center table-action-btn disabled:hidden"
                  />
                ) : (
                  <Button
                    size="small"
                    type="link"
                    shape="circle"
                    icon={
                      <Text type="secondary">
                        <DownloadOutlined
                          style={{ fontSize: 20, lineHeight: 1 }}
                        />
                      </Text>
                    }
                    onClick={() => onDownloadFile(file)}
                    className="flex center table-action-btn disabled:hidden"
                  />
                )}
              </Flex>
            </Flex>
          )
        })}
      </div>
      <FilePreviewModal
        visible={!!selectedDocument}
        onClose={() => setSelectedDocument(null)}
        doc={selectedDocument}
      />
    </>
  )
}
